import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Box, Typography } from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import env from '../../../../../config/env';

const HOW_TO_CREATE_CNPJ_URL = env.URL_GOV_BR_CNPJ_HOW_TO_CREATE?.trim() || '';

export const BankAccountCnpjBanner = ({ t, recommend = false }) => {
  const titleKey = recommend
    ? 'bank_info.cnpj_banner.recommend_title'
    : 'bank_info.cnpj_banner.require_title';
  const descKey = recommend
    ? 'bank_info.cnpj_banner.recommend_description'
    : 'bank_info.cnpj_banner.require_description';

  return (
    <Box
      sx={{
        width: { xs: '100%', md: '50%' },
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '2px',
        px: { xs: 1.5, md: 1.75 },
        py: { xs: 1.4, md: 1.5 },
        mb: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.1 }}>
        <InfoOutlinedIcon
          sx={{
            mt: '1px',
            fontSize: 16,
            color: 'primary.main',
            flexShrink: 0,
          }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: 16,
              lineHeight: 1.2,
              fontWeight: 500,
              mb: 0.75,
            }}
          >
            {t(titleKey)}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: 14,
              fontWeight: 400,
              lineHeight: 1.25,
              mb: 1.25,
            }}
          >
            {t(descKey)}
          </Typography>
          <WButton
            variant="contained"
            label={t('bank_info.cnpj_banner.cta_label')}
            fullWidth
            endIcon={<OpenInNewOutlinedIcon sx={{ fontSize: 14 }} />}
            component="a"
            href={HOW_TO_CREATE_CNPJ_URL || undefined}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!HOW_TO_CREATE_CNPJ_URL}
            sx={{
              fontSize: 13,
              fontWeight: 400,
              letterSpacing: '0.02em',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
